import React from 'react'
import { Link, NavLink } from 'react-router-dom'
import { connect } from 'react-redux'
import { post } from 'axios'
import { Spinner } from '../Spinner'

import { userActions } from '../_actions'

class RegisterPage extends React.Component {
  constructor(props) {
    super(props)

    const { user } = this.props

    if (user.first_name && user.first_name != 'Guest') {
      this.state = {
        editProfile: true,
        userNew: {
          first_name: user.first_name,
          last_name: user.last_name,
          email: user.email,
          password: '',
          cabinet: user.cabinet,
          favorites: user.favorites,
          access_level: user.access_level,
          img_url: user.img_url ? 'data:image/png;base64,' + user.img_url : '',
          _id: user._id,
        },
        img_blob_url: '',
        submitted: false,
        fetchInProgress: false,
      }
    } else {
      this.state = {
        editProfile: false,
        userNew: {
          first_name: '',
          last_name: '',
          email: '',
          password: '',
          cabinet: user.cabinet ? user.cabinet : [],
          favorites: user.favorites ? user.favorites : [],
          access_level: 1,
          img_url: '',
        },
        img_blob_url: '',
        submitted: false,
        fetchInProgress: false,
      }
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)

    this.onImageUploadFormSubmit = this.onImageUploadFormSubmit.bind(this)
    this.onImageUploadChange = this.onImageUploadChange.bind(this)
    this.imageUpload = this.imageUpload.bind(this)
  }

  handleChange(event) {
    const { name, value } = event.target
    const { userNew } = this.state
    this.setState({
      userNew: {
        ...userNew,
        [name]: value,
      },
    })
  }

  handleSubmit(event) {
    event.preventDefault()

    this.setState({ submitted: true })
    const { userNew } = this.state
    const { dispatch } = this.props
    if (
      userNew.first_name &&
      userNew.last_name &&
      userNew.email &&
      this.validateEmail(userNew.email) &&
      this.state.editProfile
    ) {
      dispatch(userActions.update(userNew))
    } else if (
      userNew.first_name &&
      userNew.last_name &&
      userNew.email &&
      this.validateEmail(userNew.email) &&
      userNew.password
    ) {
      //dispatch(userActions.register(user));
      dispatch(
        userActions.login(
          userNew.email,
          userNew.password,
          userNew.first_name,
          userNew.last_name,
          userNew.cabinet,
          userNew.favorites,
          userNew.keyIngredients,
          userNew._id,
          this.state.editProfile
        )
      )
    }
  }

  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(email).toLowerCase())
  }

  // BEGIN PROFILE IMAGE
  onImageUploadFormSubmit(e) {
    e.preventDefault() // Stop form submit
    this.imageUpload(this.state.file).then((response) => {
      console.log(
        'onImageUploadFormSubmit - image upload response data:',
        response.data
      )
      const { userNew } = this.state
      this.setState({
        img_blob_url: response.data.img_url,
        userNew: {
          ...userNew,
          ['_id']: response.data._id,
        },
      })
    })
  }

  onImageUploadChange(e) {
    //this.setState({file:e.target.files[0]})  this.state.file

    // before making call, set fetch flag
    this.setState({ fetchInProgress: true })

    this.imageUpload(e.target.files[0]).then((response) => {
      // revolutionary:
      //const contentType = 'image/png';
      //const blob = this.b64toBlob(response.data, contentType);
      //const blobUrl = URL.createObjectURL(blob);

      //const img = document.createElement('img');
      //img.src = blobUrl;
      //document.body.appendChild(img);
      // end revolutionary

      const { userNew } = this.state
      this.setState({
        fetchInProgress: false,
        img_blob_url: 'data:image/png;base64,' + response.data.img_url,
        userNew: {
          ...userNew,
          ['_id']: response.data._id,
        },
      })
    })
  }

  imageUpload(file) {
    const { userNew } = this.state
    const url = userNew._id
      ? 'https://fixadrink-api.herokuapp.com/api/user/images/' + userNew._id
      : 'https://fixadrink-api.herokuapp.com/api/user/images'

    const formData = new FormData()

    formData.append('file', file)
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    }
    return post(url, formData, config)
  }
  // END PROFILE IMAGE

  render() {
    const { registering, loggedIn } = this.props
    const { userNew, submitted, editProfile } = this.state
    return (
      <div className="col-md-6 col-md-offset-3">
        <h2 className="register-h2">
          {editProfile ? 'Edit Profile' : 'Create an Account'}
        </h2>
        <form name="form" onSubmit={this.handleSubmit}>
          <div
            className={
              'form-group' +
              (submitted && !userNew.first_name ? ' has-error' : '')
            }
          >
            <label htmlFor="first_name">First Name</label>
            <input
              type="text"
              className="form-control"
              name="first_name"
              value={userNew.first_name}
              onChange={this.handleChange}
            />
            {submitted && !userNew.first_name && (
              <div className="help-block">First Name is required</div>
            )}
          </div>
          <div
            className={
              'form-group' +
              (submitted && !userNew.last_name ? ' has-error' : '')
            }
          >
            <label htmlFor="last_name">Last Name</label>
            <input
              type="text"
              className="form-control"
              name="last_name"
              value={userNew.last_name}
              onChange={this.handleChange}
            />
            {submitted && !userNew.last_name && (
              <div className="help-block">Last Name is required</div>
            )}
          </div>
          <div
            className={
              'form-group' +
              (submitted &&
              (!userNew.email || !this.validateEmail(userNew.email))
                ? ' has-error'
                : '')
            }
          >
            <label htmlFor="email">Email</label>
            <input
              type="text"
              className="form-control"
              name="email"
              value={userNew.email}
              onChange={this.handleChange}
            />
            {submitted && !userNew.email && (
              <div className="help-block">Email is required</div>
            )}
            {submitted && !this.validateEmail(userNew.email) && (
              <div className="help-block">Email is not valid</div>
            )}
          </div>
          {!editProfile && (
            <div
              className={
                'form-group' +
                (submitted && !userNew.password ? ' has-error' : '')
              }
            >
              <label htmlFor="password">Password</label>
              <input
                type="password"
                className="form-control"
                name="password"
                value={userNew.password}
                onChange={this.handleChange}
              />
              {submitted && !userNew.password && (
                <div className="help-block">Password is required</div>
              )}
            </div>
          )}

          <div
            className={
              'form-group' + (submitted && !userNew.img_url ? ' has-error' : '')
            }
          >
            <label htmlFor="img_url">Profile Image</label> (optional)
            <div>
              <label for="image_upload_input">
                {this.state.img_blob_url ? (
                  <img src={this.state.img_blob_url} alt="img" />
                ) : userNew.img_url ? (
                  <img src={userNew.img_url} alt="img" />
                ) : (
                  <div class="btn btn-default btn-circle">
                    <i class="fa fa-image"></i>
                  </div>
                )}
                <input
                  type="file"
                  id="image_upload_input"
                  onChange={this.onImageUploadChange}
                />
              </label>
            </div>
          </div>

          <input
            type="hidden"
            className="form-control"
            name="img_url"
            value={userNew.img_url}
            onChange={this.handleChange}
          />

          <div
            className={
              'form-group' +
              (submitted && !userNew._id && !userNew.img_url
                ? ' has-error'
                : '')
            }
          >
            <input
              type="hidden"
              className="form-control"
              name="_id"
              value={userNew._id}
            />
            {/*submitted && (!userNew._id && !userNew.img_url) &&
                        <div className="help-block">Profile image is required</div>
                        */}
          </div>

          <div className="form-group">
            <button className="btn btn-primary">
              {editProfile ? 'Save Profile' : 'Register'}
            </button>
            {registering && (
              <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
            )}
            <Link to="/" className="btn btn-link">
              Cancel
            </Link>

            {editProfile && (
              <span>
                <Link to="/change_password" className="btn btn-link">
                  Change Password
                </Link>
                {loggedIn && <Link to="/login">Logout</Link>}
              </span>
            )}
          </div>

          {this.state.fetchInProgress && <Spinner />}
        </form>
        {editProfile && (
          <NavLink to={'/delete_account'}>Delete Account page</NavLink>
        )}
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { authentication } = state
  const { user, loggedIn } = authentication
  const { registering } = state.registration
  return {
    registering,
    user,
    loggedIn,
  }
}

const connectedRegisterPage = connect(mapStateToProps)(RegisterPage)
export { connectedRegisterPage as RegisterPage }



// WEBPACK FOOTER //
// ./src/RegisterPage/RegisterPage.jsx